<template>
  <v-overlay class="overlay-blur" v-if="loading" :value="loading">
    <div class="bg-glow"></div>
    <div style="margin: auto">
      در حال بارگذاری...
    </div>

    <div v-if="false" class="card">
      <div class="head">
        <div class="subtitle">
          <span class="dots">
            <span></span><span></span><span></span>
          </span>
          در حال بارگذاری...
        </div>
      </div>

      <div v-if="false" class="progress-row">
        <div class="ring">
          <svg viewBox="0 0 36 36">
            <path
                class="ring-track"
                d="M18 2.0845
                 a 15.9155 15.9155 0 0 1 0 31.831
                 a 15.9155 15.9155 0 0 1 0 -31.831"
            />
            <path
                class="ring-progress"
                :stroke-dasharray="dashArray(loadingProgress)"
                d="M18 2.0845
                 a 15.9155 15.9155 0 0 1 0 31.831
                 a 15.9155 15.9155 0 0 1 0 -31.831"
            />
          </svg>
          <div class="ring-text">
            <div class="pct">{{ loadingProgress }}%</div>
            <div class="pct-sub">پیشرفت</div>
          </div>
        </div>

        <div class="bar-wrap">
          <div class="bar-top">
            <span class="bar-label">پیشرفت</span>
            <span class="bar-val">{{ loadingProgress }}%</span>
          </div>
          <div class="bar">
            <div class="bar-fill" :style="{ width: loadingProgress + '%' }"></div>
          </div>

          <div class="meta">
            <div class="meta-item">
              <div class="meta-k">سرعت</div>
              <div class="meta-v mono">{{ loadingSpeed }}</div>
            </div>
            <div class="meta-item">
              <div class="meta-k">وضعیت</div>
              <div class="meta-v">
                <span class="status-pill">{{ statusText }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="false" class="foot">
        <div class="flex items-center gap-2">
          <v-img
              src="/img/icons/soroosh.png"
              max-height="80"
              max-width="80"
          ></v-img>
          <span class="text-sm text-gray-400"> : POWERED BY</span>
        </div>
      </div>
    </div>
  </v-overlay>
</template>

<script>
export default {
  name: "LoadingSpinner",
  data() {
    return {
      loadingProgress: 0,
      loadingSpeed: "0.0 MB/s",
      progressInterval: null,
    };
  },
  computed: {
    loading() {
      return this.OGR > 0;
    },
    statusText() {
      if (this.loadingProgress < 25) return "آماده‌سازی";
      if (this.loadingProgress < 60) return "دریافت داده";
      if (this.loadingProgress < 90) return "پردازش";
      return "تقریباً تمام";
    },
  },
  watch: {
    loading(val) {
      // start/stop automatically
      if (val) this.startProgressSimulation();
      else this.stopProgressSimulation();
    },
  },
  mounted() {
    if (this.loading) this.startProgressSimulation();
  },
  beforeDestroy() {
    this.stopProgressSimulation();
  },
  methods: {
    startProgressSimulation() {
      if (this.progressInterval) return;

      let progress = this.loadingProgress || 0;
      this.progressInterval = setInterval(() => {
        // اگر لودینگ بسته شد، سریع پاک کن
        if (!this.loading) {
          this.stopProgressSimulation();
          return;
        }

        // نزدیک 100 کندتر میشه که طبیعی‌تر باشه
        const step = progress < 70 ? Math.random() * 6 : Math.random() * 2.2;
        progress = Math.min(progress + step, 100);
        this.loadingProgress = Math.round(progress);

        // fake speed
        const speeds = ["1.2 MB/s", "2.4 MB/s", "3.1 MB/s", "4.8 MB/s", "2.9 MB/s", "1.7 MB/s"];
        this.loadingSpeed = speeds[Math.floor(Math.random() * speeds.length)];

        // وقتی 100 شد، همونجا نگه می‌داریم تا overlay با OGR بسته شه
      }, 180);
    },
    stopProgressSimulation() {
      if (this.progressInterval) clearInterval(this.progressInterval);
      this.progressInterval = null;
      this.loadingProgress = 0;
      this.loadingSpeed = "0.0 MB/s";
    },
    dashArray(percent) {
      const p = Math.min(100, Math.max(0, Number(percent) || 0));
      const safe = p === 0 ? 0.01 : p;
      return `${safe}, 100`;
    },
  },
};
</script>

<style scoped>
/* overlay base */
.overlay {
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(2, 6, 23, 0.82);
  backdrop-filter: blur(18px) saturate(140%);
  -webkit-backdrop-filter: blur(18px) saturate(140%);
}

/* animated neon background */
.bg-glow {
  position: absolute;
  inset: -140px;
  pointer-events: none;
  filter: blur(80px);
  opacity: 0.55;
  background:
      radial-gradient(circle at 20% 15%, rgba(16,185,129,0.22), transparent 55%),
      radial-gradient(circle at 80% 70%, rgba(99,102,241,0.26), transparent 58%),
      radial-gradient(circle at 55% 40%, rgba(236,72,153,0.18), transparent 55%);
  animation: glowMove 14s ease-in-out infinite;
}

@keyframes glowMove {
  0%, 100% { transform: translate(-10px, -8px) scale(1); opacity: 0.55; }
  50%      { transform: translate(18px, 14px) scale(1.06); opacity: 0.65; }
}

/* glass card */
.card {
  position: relative;
  width: min(520px, 92vw);
  border-radius: 28px;
  padding: 22px 22px 18px;
  background: rgba(2, 6, 23, 0.55);
  border: 1px solid rgba(255,255,255,0.10);
  box-shadow: 0 28px 90px rgba(0,0,0,0.60), inset 0 1px 0 rgba(255,255,255,0.06);
  overflow: hidden;
}

.card::before {
  content: "";
  position: absolute;
  inset: 0;
  pointer-events: none;
  background:
      radial-gradient(circle at 18% 12%, rgba(255,255,255,0.08), transparent 45%),
      linear-gradient(to bottom, rgba(255,255,255,0.06), transparent 35%);
}

.card > * { position: relative; z-index: 1; }

/* header */
.head {
  text-align: center;
  margin-bottom: 14px;
  margin-top: 14px;
}
.brand {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  border-radius: 999px;
  border: 1px solid rgba(255,255,255,0.10);
  background: rgba(255,255,255,0.05);
}
.badge-dot{
  width: 10px; height: 10px; border-radius: 999px;
  background: rgba(52,211,153,1);
  box-shadow: 0 0 0 6px rgba(52,211,153,0.14);
  animation: pulseDot 1.4s ease-in-out infinite;
}
@keyframes pulseDot { 0%,100%{ transform: scale(1); } 50%{ transform: scale(1.15);} }

.brand-title{
  font-weight: 900;
  letter-spacing: 2px;
  font-size: 20px;
  background: linear-gradient(135deg, rgba(129,140,248,1), rgba(236,72,153,1), rgba(52,211,153,1));
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.subtitle{
  margin-top: 10px;
  font-size: 13px;
  color: rgba(148,163,184,0.95);
  display: inline-flex;
  align-items: center;
  gap: 10px;
}
.dots { display: inline-flex; gap: 4px; }
.dots span{
  width: 6px; height: 6px; border-radius: 999px;
  background: rgba(255,255,255,0.35);
  animation: dotBounce 1.1s infinite;
}
.dots span:nth-child(2){ animation-delay: .15s; }
.dots span:nth-child(3){ animation-delay: .3s; }
@keyframes dotBounce{
  0%,100%{ transform: translateY(0); opacity: .45; }
  50%{ transform: translateY(-4px); opacity: .9; }
}

/* layout */
.progress-row{
  display: grid;
  grid-template-columns: 150px 1fr;
  gap: 18px;
  align-items: center;
  margin-top: 14px;
}

@media (max-width: 480px){
  .progress-row{ grid-template-columns: 1fr; }
}

/* ring */
.ring{
  position: relative;
  width: 150px;
  height: 150px;
  margin: 0 auto;
}
.ring svg{
  width: 100%;
  height: 100%;
  transform: rotate(-90deg);
  filter: drop-shadow(0 10px 30px rgba(0,0,0,0.35));
}
.ring-track{
  fill: none;
  stroke: rgba(255,255,255,0.10);
  stroke-width: 3.6;
  stroke-linecap: round;
}
.ring-progress{
  fill: none;
  stroke: rgba(129,140,248,1);
  stroke-width: 3.6;
  stroke-linecap: round;
  filter: drop-shadow(0 0 10px rgba(99,102,241,0.25));
}
.ring-text{
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.pct{
  font-size: 26px;
  font-weight: 900;
  color: rgba(226,232,240,1);
}
.pct-sub{
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 1.2px;
  color: rgba(148,163,184,0.8);
}

/* bar + meta */
.bar-wrap{ width: 100%; }
.bar-top{
  display:flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  color: rgba(148,163,184,0.9);
  margin-bottom: 8px;
}
.bar{
  height: 12px;
  border-radius: 999px;
  background: rgba(255,255,255,0.08);
  border: 1px solid rgba(255,255,255,0.10);
  overflow: hidden;
}
.bar-fill{
  height: 100%;
  border-radius: 999px;
  background: linear-gradient(90deg, rgba(16,185,129,0.85), rgba(99,102,241,0.85), rgba(236,72,153,0.75));
  box-shadow: 0 0 24px rgba(99,102,241,0.22);
  transition: width 180ms ease;
}

.meta{
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-top: 12px;
}
@media (max-width: 480px){
  .meta{ grid-template-columns: 1fr; }
}
.meta-item{
  padding: 10px 12px;
  border-radius: 16px;
  border: 1px solid rgba(255,255,255,0.10);
  background: rgba(255,255,255,0.05);
}
.meta-k{
  font-size: 11px;
  color: rgba(148,163,184,0.85);
  margin-bottom: 6px;
}
.meta-v{
  font-size: 13px;
  font-weight: 800;
  color: rgba(226,232,240,1);
}
.mono{ font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; }

.status-pill{
  display: inline-flex;
  padding: 4px 10px;
  border-radius: 999px;
  border: 1px solid rgba(255,255,255,0.10);
  background: rgba(255,255,255,0.06);
  color: rgba(196,181,253,1);
}

/* footer */
.foot{
  margin-top: 14px;
  padding-top: 12px;
  border-top: 1px solid rgba(255,255,255,0.10);
  text-align: center;
}
.hint{
  font-size: 11px;
  color: rgba(148,163,184,0.85);
}
.overlay-blur {
  backdrop-filter: blur(20px) saturate(180%);
  background: linear-gradient(135deg,
  rgba(10, 10, 30, 0.95) 0%,
  rgba(30, 20, 50, 0.9) 50%,
  rgba(50, 30, 70, 0.85) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}

</style>
